export const POLICY = 1
export const LICENCE = 2
export const CERTIFICATE = 3
export const OTHER = 4
